import '.fu{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fv{padding-left:1.5rem;}.ssr-plugin'
import '.fw{margin:1rem 0;}.ssr-plugin'
import '.fx{color:var(--gray-700);}.ssr-plugin'
import '.fy{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fu fv fw fx fy"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
